<template>
  <div class="py-2 px-6">
    <label for="transport_date" class="block text-sm font-medium leading-6 text-secondary">Dato</label>
    <div class="relative">
      <select id="combobox" v-model="selectedDate"
          class="peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium"
          role="combobox" aria-controls="options" aria-expanded="false">
          <optgroup v-for="(dates, week) in dateOptions" :label="week" :key="week">
            <option v-for="date in dates" :key="date.formatted" :value="date.formatted">{{ date.formatted }}</option>
          </optgroup>
      </select>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'DateSelector',
  setup () {
    const store = useStore()
    const selectedDate = ref('')

    const formatDate = (date: Date) => {
      const options: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      const formattedDate = date.toLocaleDateString('da-DK', options)
      return formattedDate.replace(' den ', ' d. ')
    }

    const dateOptions = computed(() => {
      const today: Date = new Date();
      const isMonday = today.getDay() === 1;

      const startOfWeek: Date = isMonday
        ? new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() + 1 - (isMonday ? 7 : 0))
        : new Date(today.setDate(today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1)));

      const endOfWeek: Date = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + (isMonday ? 13 : 6)); // Extend for two weeks if Monday

      console.log(startOfWeek)
      console.log(endOfWeek)
      const weeks: Record<string, Array<{ formatted: string; actual: Date }>> = {};
      const currentDate: Date = new Date(startOfWeek);

      while (currentDate <= endOfWeek) {
        const weekNumber = `Uge ${getISOWeekNumber(currentDate)}`;
        if (!weeks[weekNumber]) {
          weeks[weekNumber] = [];
        }
        weeks[weekNumber].push({ formatted: formatDate(currentDate), actual: new Date(currentDate) });
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return weeks;
    });

    function getISOWeekNumber(d: Date): number {
      const date: Date = new Date(d.getTime());
      date.setHours(0, 0, 0, 0);
      date.setDate(date.getDate() + 3 - (date.getDay() || 7));
      const yearStart: Date = new Date(date.getFullYear(), 0, 1);
      return Math.ceil(((date.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
    }

    const getSelectedDate = (date: string) => {
      const currentDate = new Date()
      const startOfWeek = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + (currentDate.getDay() === 0 ? -6 : 1)))
      const endOfWeek = new Date(startOfWeek.getTime())
      endOfWeek.setDate(startOfWeek.getDate() + 6)

      let d = new Date(startOfWeek)

      do {
        const compareDate = formatDate(new Date(d))

        if (date === compareDate) {
          console.log('found date: ', d)
          return d
        }
        d = new Date(d.setDate(d.getDate() + 1))
      } while (d <= endOfWeek)

      return d
    }

    onMounted(() => {
      const reportSelectedDate = store.getters['report/reportSelectedDate'] || new Date()
      selectedDate.value = formatDate(reportSelectedDate)
    })

    watch(selectedDate, (newValue) => {
      if (newValue) {
        const allDates = Object.values(dateOptions.value).flat();
        const dateObject = allDates.find(date => date.formatted === newValue)?.actual;
        if (dateObject) {
          store.commit('report/UPDATE_REPORT', { key: 'date', value: dateObject });
          store.commit('report/SET_REPORT_SELECTED_DATE', dateObject);
        }
      }
    });

    return { selectedDate, dateOptions }
  }
})
</script>
